import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const ParametroProSolutoBService = 
{
    deletarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'parametros-psb/excel/deletar', 'excelParametroPSBDeletar');
    },
    parametroProSolutoBExcelPost(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'parametros-psb/excel', 'excelPSB');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('parametros-psb/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('parametros-psb/eventGrid', {});
    }
}

export default ParametroProSolutoBService;